import React from "react";
import { ShoppingBag, Heart, Eye } from "lucide-react";
import { useRegistry } from "@/context/RegistryContext";

const BOTTOM_NAV = {
  container: "bottom-nav",
  marketplace: "bottom-nav-marketplace",
  registry: "bottom-nav-registry",
  guest: "bottom-nav-guest",
};

export const BottomNav = () => {
  const { view, setView, registry } = useRegistry();

  const scrollTo = (id) => {
    const el = document.querySelector(`[data-testid="${id}"]`);
    if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
  };

  const goMarketplace = () => {
    setView("mother");
    setTimeout(() => scrollTo("nationwide-collection"), 60);
  };
  const goRegistry = () => {
    setView("mother");
    setTimeout(() => scrollTo("mother-registry"), 60);
  };
  const goGuest = () => {
    setView("guest");
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  const Item = ({ testId, active, onClick, icon: Icon, label, badge }) => (
    <button
      data-testid={testId}
      onClick={onClick}
      className={`flex-1 flex flex-col items-center gap-1 py-2 transition-colors ${
        active ? "text-[#D98A71]" : "text-[#5C6B62] hover:text-[#2D3732]"
      }`}
    >
      <div className="relative">
        <Icon size={20} strokeWidth={1.6} />
        {badge > 0 && (
          <span className="absolute -top-1.5 -right-2.5 min-w-[16px] h-4 px-1 rounded-full bg-[#D98A71] text-[#FDFBF7] text-[9px] font-medium flex items-center justify-center">
            {badge}
          </span>
        )}
      </div>
      <span className="text-[10px] tracking-[0.15em] uppercase">{label}</span>
    </button>
  );

  return (
    <div
      data-testid={BOTTOM_NAV.container}
      className="md:hidden fixed bottom-0 inset-x-0 z-40"
    >
      <div className="mx-3 mb-3 rounded-2xl glass-nav border border-[#E5E1D8] shadow-[0_20px_40px_-24px_rgba(45,55,50,0.25)]">
        <div className="flex items-stretch px-2 py-1">
          <Item
            testId={BOTTOM_NAV.marketplace}
            active={view === "mother"}
            onClick={goMarketplace}
            icon={ShoppingBag}
            label="Marketplace"
          />
          <Item
            testId={BOTTOM_NAV.registry}
            active={view === "mother"}
            onClick={goRegistry}
            icon={Heart}
            label="My Registry"
            badge={registry.length}
          />
          <Item
            testId={BOTTOM_NAV.guest}
            active={view === "guest"}
            onClick={goGuest}
            icon={Eye}
            label="Guest View"
          />
        </div>
      </div>
    </div>
  );
};
